<template>
  <div class="robins-egg-bkgr pa-8">
    <div class="stockli-admin-container">
      <div class="h2">Admin Reports</div>

      <v-form ref="form" @submit.prevent="RunReport">
        <div class="h5 mb-6">Choose a date range</div>
        <v-menu v-model="pickingStart" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="dateStart" label="Start Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" />
          </template>
          <v-date-picker v-model="dateStart" @input="pickingStart = false" :rules="[ruleRequired]" />
        </v-menu>
        <v-menu v-model="pickingEnd" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="dateEnd" label="End Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" />
          </template>
          <v-date-picker v-model="dateEnd" @input="pickingEnd = false" :rules="[ruleRequired]" />
        </v-menu>
        <v-btn type="submit" :loading="loading" :disabled="loading" class="my-6">Download CSV</v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
import { endOfMonth, startOfMonth, addMonths } from "date-fns";

import { Utilities } from "@/services/utilities";
import API from "@/services/api";

export default {
  name: "Reports",
  components: {
  },
  data: () => ({
    loading: false,

    dateStart: Utilities.GetZohoDate(startOfMonth(addMonths(new Date(), -1))),
    dateEnd: Utilities.GetZohoDate(endOfMonth(addMonths(new Date(), -1))),

    pickingStart: false,
    pickingEnd: false,

    ruleRequired: v => !!v || "This field is required",
  }),
  computed: {
  },
  mounted() {
  },
  methods: {
    async RunReport() {
      try {
        this.loading = true;
        await API.RunReport(this.dateStart, this.dateEnd);
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>
<style scoped lang="scss">
</style>
